import {ErrorWithFieldErrors, GeneralError} from 'src/api/types'

export const isErrorWithFieldErrors = (error: GeneralError | ErrorWithFieldErrors)
: error is ErrorWithFieldErrors => {
  //eslint-disable-next-line
  return (error as ErrorWithFieldErrors).fieldErrors !== undefined
}
